/*

NOTE: tag is not supported in horizontal menu

Array of object

Top level object can be:
2. Group (Group can have navItems as children)
3. navItem

* Supported Options

/--- nav Grp (top level grp is called header group) ---/

title
icon (if it's on top/second level)
children

/--- nav Item (top level item is called header link) ---/

icon (if it's on top/second level)
title
route: [route_obj/route_name] (I have to resolve name somehow from the route obj)

*/
import administracion from './administracion'
import almacenDocumentos from './almacenDocumentos'
import contabilidad from './contabilidad'
import controlAsc from './controlAsc'
import controlBines from './controlBines'
import controlCalidad from './controlCalidad'
import controlCostos from './controlCostos'
import controlTicket from './controlTicket'
import costos from './costos'
import dashboard from './dashboard'
import evoucher from './evoucher'
import exportacion from './exportacion'
import financiero from './financiero'
import inventarioConsumo from './inventarioConsumo'
import legal from './legal'
import logistica from './logistica'
import mantenimiento from './mantenimiento'
import marketing from './marketing'
import palletizado from './palletizado'
import personas from './personas'
import produccion from './produccion'
import profremar from './profremar'
import recursosHumanos from './recursosHumanos'
import sistemaDocumentos from './sistemaDocumentos'
import sistemas from './sistemas'
import tableroControl from './tableroControl'
import temperatura from './temperatura'
import tributacion from './tributacion'
import ventas from './ventas'
import ventasNacionales from './ventasNacionales'
import compras from '../vertical/compras'
import cxp from '../vertical/cxp'
import personaPG from '../vertical/persona-pg'
import tributacionV2 from '../vertical/tributacion-pg'

// Array of sections
export default [
    ...dashboard,
    ...almacenDocumentos,
    ...contabilidad,
    ...controlCalidad,
    ...controlBines,
    ...exportacion,
    ...financiero,
    ...logistica,
    ...personas,
    ...produccion,
    ...tributacion,
    ...ventasNacionales,
    ...sistemas,
    ...palletizado,
    ...ventas,
    ...legal,
    ...recursosHumanos,
    ...sistemaDocumentos,
    ...controlCostos,
    ...controlAsc,
    ...temperatura,
    ...costos,
    ...administracion,
    ...profremar,
    ...compras,
    ...tableroControl,
    ...controlTicket,
    ...mantenimiento,
    ...inventarioConsumo,
    ...cxp,
    ...tributacionV2,
    ...marketing,
    ...personaPG,
    ...evoucher,
]
